
// Countdown to a fixed launch date 14 days out — purely demonstrative.
const target = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);
function tick() {
  const diff = Math.max(0, target.getTime() - Date.now());
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const s = Math.floor((diff % (1000 * 60)) / 1000);
  document.getElementById('cd-days').textContent  = String(d).padStart(2, '0');
  document.getElementById('cd-hours').textContent = String(h).padStart(2, '0');
  document.getElementById('cd-mins').textContent  = String(m).padStart(2, '0');
  document.getElementById('cd-secs').textContent  = String(s).padStart(2, '0');
}
tick();
setInterval(tick, 1000);

document.getElementById('notify-form').addEventListener('submit', (e) => {
  e.preventDefault();
  e.stopPropagation();
  document.getElementById('notify-form').hidden = true;
  document.getElementById('notify-success').hidden = false;
});
